import { Get, Post, Put, PutFormData} from "../Request/Api";


export default {
  state: { NewsLetter: [],},
  getters: {
    GetNewsLetter(state: any) {
      return state.NewsLetter;
    },},
  actions: {
    async AddAllMembership({ commit }: any, payload: any) {
      return await Post("NewsLetter/AddNewsLetter", payload).then((res) => {
        console.log(res);
      });
    },

    async GetALLNewsLetter({ commit } :any , payload :any ) {
      return await Get(`NewsLetter/GetNewsLetterbyUserId?userId=${payload}`).then((res :any) => {
        return commit("SetAllNewsLetter", res.data.Data);
      });
    },
    

 
    async updatenewsletter({ commit }: any, payload: any) {
      return await Put(
        `NewsLetter/UpdateNewsLetter`,payload
      ).then((res: any) => {
        return res.data.Data;
      });
    },
    
    async AcceptRejectInstructorCoordinator({ commit }: any, payload: any) {
      return await Put(
        `NewsLetter/UpdateNewsLetter`,payload
      ).then((res: any) => {
        commit("SetAllNewsLetter", res.data.Data);
        return res.data.Data;
      });
    },
 
  },
  mutations: {
    SetAllNewsLetter(state :any, payload:any) {
      state.NewsLetter = payload;
    },
  },
};
